export const downloadLinkHandler = async (
  downloadLink: string,
  name: string,
  replaceLink: string,
  nextApi: string
) => {
  try {
    const response = await fetch(downloadLink.replace(replaceLink, nextApi));

    if (!response.ok) {
      throw new Error("Failed to fetch the file");
    }

    const reader = response.body?.getReader();
    const stream = new ReadableStream({
      start(controller) {
        function push() {
          reader?.read().then(({ done, value }) => {
            if (done) {
              controller.close();
              return;
            }
            controller.enqueue(value);
            push();
          });
        }
        push();
      },
    });

    const newResponse = new Response(stream);
    const blob = await newResponse.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

type validVideoTypes = "mp4" | "webm" | "ogg";
export const getVideoType = (theUrl: string) => {
  const extensionMap = {
    mp4: "video/mp4",
    webm: "video/webm",
    ogg: "video/ogg",
  };

  // Extract the file extension from the URL
  const extension = theUrl?.split(".")?.pop()?.toLowerCase();

  // Return the corresponding MIME type, or default to "video/mp4"
  return extension
    ? extensionMap[extension as validVideoTypes] || "video/mp4"
    : "video/mp4";
};
